import { render } from "./PlaylistComponent.vue?vue&type=template&id=12680828&scoped=true"
import script from "./PlaylistComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistComponent.vue?vue&type=script&lang=js"

import "./PlaylistComponent.vue?vue&type=style&index=0&id=12680828&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12680828"]])

export default __exports__